export const getYear = state => state.reportAppUsage.getIn(['list', 'year'])
export const getData = state => state.reportAppUsage.getIn(['list', 'data'])
export const getFetching = state => state.reportAppUsage.getIn(['list', 'fetching'])
export const getError = state => state.reportAppUsage.getIn(['list', 'error'])
